import React from "react";
import { services } from "./data";
import ServiceCard from "./ServiceCard";

const ServicesSection = () => {
  return (
    <section className="px-4 md:px-16 py-12 md:w-4/5 2xl:w-3/5 container m-auto">
      <h2 className="text-center text-xl md:text-2xl font-outfitRegular mb-10">
        Core Services <span className="font-bold">We Offer</span>
      </h2>
      <div className="space-y-16">
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            {...service}
            reverse={index % 2 === 0}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
